import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const Login = ({ showAlert }) => {
  const [showPassword, setShowPassword] = useState(false);

  const [credentials, setCredentials] = useState({ email: "", password: "" });
  let navigate = useNavigate();

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: credentials.email,
        password: credentials.password,
      }),
    });
    const json = await response.json();
    if (json.success) {
      showAlert({
        type: "success",
        title: "Success",
        message: "Logged in successfully.",
      });
      localStorage.setItem("token", json.authtoken);
      navigate("/home");
    } else {
      showAlert({
        type: "error",
        title: "Error",
        message: "Incorrect email or password.",
      });
    }
  };

  const CloudIcon = () => (
    <svg
      style={{ height: "30px", width: "30px", color: "#eab308" }}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z"></path>
    </svg>
  );

  const handleLink = () => {
    navigate("/signup");
  };

  const handleForgotPassword = () => {
    if (!credentials.email) {
      showAlert({
        type: "info",
        title: "Importent",
        message: "Plese enter registered email.",
      });
    } else {
      showAlert({
        type: "success",
        title: "Success",
        message: "Check your inbox for the password reset link.",
      });
    }
  };

  return (
    <div
      className="login-page"
      style={{
        minHeight: "97vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "#FFFDEA",
        paddingTop: "40px",
        boxSizing: "border-box",
        overflow: "hidden",
      }}
    >
      {/* Logo and Title */}
      <div style={{ textAlign: "center", marginBottom: "0.5rem" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
          }}
        >
          <div>
            <CloudIcon />
          </div>
          <h1
            style={{
              fontSize: "32px",
              fontWeight: "bold",
              color: "#111827",
              margin: 0,
            }}
          >
            MinDrop
          </h1>
        </div>
        <p
          style={{
            fontSize: "0.9rem",
            color: "rgb(75, 85, 99)",
            marginTop: "5px",
          }}
        >
          Your thoughts, safely stored in the cloud
        </p>
      </div>

      {/* Login Form */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <form
          onSubmit={handleSubmit}
          style={{
            width: "100%",
            maxWidth: "440px",
            minHeight: "420px",
            padding: "24px",
            backgroundColor: "rgb(255, 255, 255)",
            borderRadius: "12px",
            boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.1)",
            boxSizing: "border-box",
          }}
        >
          <h2
            style={{
              textAlign: "center",
              fontSize: "24px",
              marginBottom: "0.5rem",
            }}
          >
            Welcome back
          </h2>
          <p
            style={{
              fontSize: "0.9rem",
              color: "rgb(75, 85, 99)",
              textAlign: "center",
            }}
          >
            Log in to access your notes and keep working.
          </p>

          <label
            style={{
              display: "block",
              marginTop: "20px",
              marginBottom: "6px",
              fontWeight: "500",
            }}
          >
            Email
          </label>
          <input
            type="email"
            name="email"
            value={credentials.email}
            onChange={handleChange}
            placeholder="you@gmail.com"
            required
            style={{
              width: "100%",
              padding: "10px",
              marginBottom: "25px",
              borderRadius: "6px",
              border: "1px solid #d1d5db",
              fontSize: "14px",
            }}
          />

          <label
            style={{ display: "block", marginBottom: "6px", fontWeight: "500" }}
          >
            Password
          </label>
          <input
            type={showPassword ? "text" : "password"}
            name="password"
            value={credentials.password}
            onChange={handleChange}
            placeholder="Enter your Password"
            required
            style={{
              width: "100%",
              padding: "10px",
              marginBottom: "7px",
              borderRadius: "6px",
              border: "1px solid #d1d5db",
              fontSize: "14px",
            }}
          />
          <div style={{ position: "relative", marginBottom: "1rem" }}>
            <span
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: "absolute",
                right: "10px",
                top: "35%",
                transform: "translateY(-230%)",
                cursor: "pointer",
                color: "#6b7280",
              }}
            >
              {showPassword ? <FaEye /> : <FaEyeSlash />}
            </span>
            <button
            type="button"
              className="btn btn-link"
              onClick={handleForgotPassword}
              style={{
                all: "unset",
                cursor: "pointer",
                color: "#eab308",
                fontSize: "13px",
                marginBottom: "20px",
                marginLeft: "290px",
                textDecoration: "underline",
              }}
            >
              Forgot Password?
            </button>
          </div>

          <button
            type="submit"
            style={{
              width: "100%",
              padding: "10px",
              backgroundColor: "#eab308",
              color: "white",
              border: "none",
              borderRadius: "6px",
              fontSize: "16px",
              fontWeight: "500",
              cursor: "pointer",
              transition: "background-color 0.2s",
            }}
          >
            Log In
          </button>
          <div
            style={{
              fontSize: "0.9rem",
              color: "rgb(75, 85, 99)",
              textAlign: "center",
              marginTop: "1rem",
            }}
          >
            <p>
              New to MinDrop?
              <button
                className="btn btn-link"
                onClick={handleLink}
                style={{
                  all: "unset",
                  cursor: "pointer",
                  color: "#eab308",
                  marginLeft: "5px",
                  textDecoration: "underline",
                }}
              >
                Signup
              </button>
            </p>
          </div>
        </form>
      </div>

      {/* Footer */}
      <div
        style={{
          marginTop: "30px",
          textAlign: "center",
          fontSize: "0.85rem",
          color: "#6b7280",
        }}
      >
        <p className="mb-2">MinDrop features:</p>
        <div style={{ marginBottom: "4px" }}>
          🗂 Organized Notes &nbsp;&nbsp; 🔐 Secure Storage &nbsp;&nbsp; ☁ Cloud
          Sync &nbsp;&nbsp; ⚡ Fast Search
        </div>
      </div>
    </div>
  );
};

export default Login;
